import { set, cloneDeep } from 'lodash';
import type { Field } from '../../typescript/types/FieldComponentProps';

type NestedFields = {
  [key: number]: Field['value'] | NestedFields | NestedFields[];
};

interface UpdateDeep {
  <T extends object>(
    prevFields: T,
    field: Field['name'],
    value: Field['value'] | NestedFields
  ): T;
}

export const FIELD_MODES = {
  EDIT: 'edit',
  VIEW: 'view',
};

export const FIELD_COLUMN_SIZES = {
  NONE: '',
  FULL: 'pm-flex-col',
  SMALL: 'pm-flex-col-small',
  MEDIUM: 'pm-flex-col-medium',
  LARGE: 'pm-flex-col-large',
  MAX: 'pm-flex-col-max',
  TINY: 'pm-flex-col-tiny',
} as const;

export const updateDeep: UpdateDeep = <T extends object>(
  prevFields: T,
  field: Field['name'],
  value: Field['value'] | NestedFields
): T => {
  const updatedFields = cloneDeep(prevFields);
  set(updatedFields, field, value);
  return updatedFields;
};

// export const handleFieldChange: FieldsDeepUpdate = (fieldName, value, setFields) => {
//   setFields((prevFields) => {
//     return updateDeep(prevFields, fieldName, value);
//   });
// };
